import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Collapse } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsDown, faThumbsUp } from '@fortawesome/pro-solid-svg-icons';

import { setOwnerContactMethodScore } from '../store/actions/owners';
import { connect } from 'react-redux';

function ContactMethod({
  owner,
  contactMethodKey,
  renderDisplayName,
  setOwnerContactMethodScore
}) {
  const [showMore, setShowMore] = useState(false);

  const upvoted = contactMethod => contactMethod.connectRankScore > 0;
  const downvoted = contactMethod => contactMethod.connectRankScore < 0;

  const handleUpdate = (method, newScore) => {
    setOwnerContactMethodScore(owner, contactMethodKey, method.id, newScore);
  };

  const handleUpvote = (contactMethod) => {
    const newScore = upvoted(contactMethod) ? 0 : 1;
    handleUpdate(contactMethod, newScore);
  };

  const handleDownvote = (contactMethod) => {
    const newScore = downvoted(contactMethod) ? 0 : -1;
    handleUpdate(contactMethod, newScore);
  };

  const contactsToShow = owner.contact[contactMethodKey].filter(contactMethod => !contactMethod._destroy);

  const renderedContactMethods = contactsToShow.map((contactMethod) => {
    return (
      <div className="d-flex align-items-center" key={contactMethod.id}>
        {renderDisplayName(contactMethod)}
        <div className="flex-grow-1 text-end" style={{ flex: '0 0 auto' }}>
          <Button className="p-0 pe-2" variant="link" onClick={() => handleUpvote(contactMethod)}>
            <FontAwesomeIcon
              className={
                upvoted(contactMethod) ? 'text-primary' :
                  downvoted(contactMethod) ? 'text-muted opacity-25' : 'thumbs-inactive'
              }
              icon={faThumbsUp}
            />
          </Button>
          <Button className="p-0" variant="link" onClick={() => handleDownvote(contactMethod)}>
            <FontAwesomeIcon
              className={
                downvoted(contactMethod) ? 'text-danger' :
                  upvoted(contactMethod) ? 'text-muted opacity-25' : 'thumbs-inactive'
              }
              icon={faThumbsDown}
            />
          </Button>
        </div>
      </div>
    );
  });

  const firstGroup = renderedContactMethods.slice(0, 3);
  const secondGroup = renderedContactMethods.slice(3);

  return (
    <React.Fragment>
      {firstGroup}
      {secondGroup.length > 0 && (
        <div>
          {!showMore && (
            <div className="text-center">
              <Button size="sm" variant="text-primary" onClick={() => setShowMore(true)}>Show More</Button>
            </div>
          )}
          <Collapse in={showMore}>
            <div>
              {secondGroup}
            </div>
          </Collapse>
        </div>

      )}
    </React.Fragment>
  );
}

ContactMethod.propTypes = {
  owner: PropTypes.shape({
    id: PropTypes.number.isRequired,
    contact: PropTypes.shape({
      id: PropTypes.number.isRequired,
      addresses: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        twoLine: PropTypes.arrayOf(PropTypes.string).isRequired
      })).isRequired
    })
  }),
};

export default connect(null, { setOwnerContactMethodScore })(ContactMethod);
